import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.AdminButton, {
        staticClass: "mr-2",
        attrs: {
          link: _setup.reverseFull({
            name: "admin:info_legalcase_change",
            args: [_vm.legalCase.id],
          }),
          text: "Править",
        },
      }),
      _vm._v(" "),
      _c(_setup.AdminButton, {
        staticClass: "mb-2",
        attrs: { text: _vm.legalCase.get_result_display },
      }),
      _vm._v(" "),
      _setup.context.request.user.is_staff && !_setup.isMobile
        ? _c("br")
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.AdminButton, {
        staticClass: "mb-2",
        attrs: {
          link: `${_setup.reverseFull({
            name: "admin:info_courthearing_add",
          })}?legal_case=${_vm.legalCase.id}`,
          text: "Добавить заседание",
        },
      }),
      _vm._v(" "),
      _c(
        VCard,
        {
          staticClass: "d-flex flex-column",
          class:
            _setup.isMobile && !_vm.isLegalCaseItemPage
              ? "flex-column-reverse py-5 px-2"
              : "pa-sm-6 pa-0 px-3",
          attrs: {
            href:
              _setup.isMobile || _vm.isLegalCaseItemPage
                ? undefined
                : _setup.reverseFull({
                    name: "legal_case_page",
                    args: [_vm.legalCase.id],
                  }),
            "data-qa": "legal_case_card",
            flat: _setup.isMobile,
          },
        },
        [
          _setup.isMobile && !_vm.isLegalCaseItemPage
            ? _c(
                "a",
                {
                  staticClass:
                    "d-flex align-center text-button ml-auto text-decoration-none",
                  attrs: {
                    href: _setup.reverseFull({
                      name: "legal_case_page",
                      args: [_vm.legalCase.id],
                    }),
                  },
                },
                [
                  _c("span", [_vm._v("\n        Читать далее\n      ")]),
                  _vm._v(" "),
                  _c(VIcon, { staticClass: "text--text" }, [
                    _vm._v("\n        ui-icon-arrow-right\n      "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text--text",
              class:
                _setup.isMobile && !_vm.isLegalCaseItemPage
                  ? "text-subtitle-1 mb-4"
                  : "text-h6 mb-2",
              attrs: { "data-qa": "legal_case_name" },
            },
            [_vm._v("\n      " + _vm._s(_vm.legalCase.name) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mb-2",
              class: _setup.isMobile
                ? "text-body-1 text-secondary--text"
                : "text-body-2 text-info--text",
              attrs: { "data-qa": "legal_case_number" },
            },
            [
              _vm._v(
                "\n      Дело " +
                  _vm._s(_setup.legalCaseNumber) +
                  " от " +
                  _vm._s(_setup.legalCaseDate) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          !_setup.isMobile || _vm.isLegalCaseItemPage
            ? _c(
                "div",
                {
                  staticClass: "text-body-2 text--text mb-2",
                  attrs: { "data-qa": "legal_case_description" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isLegalCaseItemPage
                          ? _vm.legalCase.description
                          : _setup.truncatedDescription
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLegalCaseItemPage
            ? [
                _c("div", { staticClass: "text-h6 text--text my-6" }, [
                  _vm._v("\n        Судебные заседания\n      "),
                ]),
                _vm._v(" "),
                _vm._l(
                  _vm.legalCase.courthearing_set.all,
                  function (courtHearing) {
                    return _c(
                      "div",
                      {
                        key: courtHearing.id,
                        staticClass:
                          "d-flex flex-sm-row flex-column ga-sm-6 ga-2 mb-8",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text--text text-subtitle-2",
                            attrs: { "data-qa": "court_date" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(courtHearing.court_hearing_dt) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column ga-3" },
                          [
                            _setup.context.request.user.is_superuser
                              ? _c(_setup.AdminButton, {
                                  attrs: {
                                    text: "править",
                                    "data-qa": "admin_button",
                                    link: _setup.reverseFull({
                                      name: "admin:info_courthearing_change",
                                      args: [courtHearing.id],
                                    }),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text--text text-subtitle-1" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(courtHearing.court) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            courtHearing.judge
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-secondary--text text-body-2",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(courtHearing.judge) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-secondary--text text-body-2",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(courtHearing.courts_decision) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            courtHearing.courts_decision_pdf.__bool__
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _setup.reverseFull({
                                        name: "courts_decision_pdf",
                                        args: [courtHearing.id],
                                      }),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            Полное решение суда\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  }
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _setup.isMobile && !_vm.isLegalCaseItemPage ? _c(VDivider) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }